import React, { useState } from 'react';
import { StyleSheet, View, Text, FlatList, TouchableOpacity, Modal } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/**
 * Componente para mostrar una lista de puntos de misión con sus detalles
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.points - Lista de puntos de la misión
 */
const MissionPointsList = ({ points }) => {
  const [selectedPoint, setSelectedPoint] = useState(null);
  
  // Ordenar los puntos por orden
  const sortedPoints = Array.isArray(points) ? [...points].sort((a, b) => a.order - b.order) : [];
  
  // Renderizar un punto de la misión
  const renderPoint = ({ item }) => (
    <TouchableOpacity 
      style={styles.pointItem}
      onPress={() => setSelectedPoint(item)}
    >
      <View style={styles.pointOrder}>
        <Text style={styles.pointOrderText}>{item.order}</Text>
      </View>
      <View style={styles.pointInfo}>
        <Text style={styles.pointName}>{item.name || `Punto ${item.order}`}</Text>
        <Text style={styles.pointCoordinates}>
          {item.location.coordinates[1].toFixed(6)}, {item.location.coordinates[0].toFixed(6)}
        </Text>
        <Text style={styles.pointAltitude}>Altitud: {item.altitude} m</Text>
      </View>
      <Ionicons name="chevron-forward" size={20} color="#7f8c8d" />
    </TouchableOpacity>
  );
  
  return (
    <View style={styles.container}>
      {points.length === 0 ? (
        <Text style={styles.emptyText}>No hay puntos definidos para esta misión</Text>
      ) : (
        <>
          <FlatList
            data={sortedPoints}
            keyExtractor={(item) => item.id.toString()}
            renderItem={renderPoint}
            style={styles.list}
          />
          
          {/* Modal de detalles del punto */}
          <Modal
            visible={selectedPoint !== null}
            transparent={true}
            animationType="fade"
            onRequestClose={() => setSelectedPoint(null)}
          >
            <View style={styles.modalOverlay}>
              <View style={styles.modalContent}>
                <View style={styles.modalHeader}>
                  <Text style={styles.modalTitle}>
                    {selectedPoint?.name || `Punto ${selectedPoint?.order}`}
                  </Text>
                  <TouchableOpacity onPress={() => setSelectedPoint(null)}>
                    <Ionicons name="close-circle" size={24} color="#e74c3c" />
                  </TouchableOpacity>
                </View>
                
                {selectedPoint && (
                  <View style={styles.modalBody}>
                    <View style={styles.detailRow}>
                      <Text style={styles.detailLabel}>Orden:</Text>
                      <Text style={styles.detailValue}>{selectedPoint.order}</Text>
                    </View>
                    
                    <View style={styles.detailRow}>
                      <Text style={styles.detailLabel}>Coordenadas:</Text>
                      <Text style={styles.detailValue}>
                        {selectedPoint.location.coordinates[1].toFixed(6)}, {selectedPoint.location.coordinates[0].toFixed(6)}
                      </Text>
                    </View>
                    
                    <View style={styles.detailRow}>
                      <Text style={styles.detailLabel}>Altitud:</Text>
                      <Text style={styles.detailValue}>{selectedPoint.altitude} m</Text>
                    </View>
                    
                    {selectedPoint.description && (
                      <View style={styles.detailRow}>
                        <Text style={styles.detailLabel}>Descripción:</Text>
                        <Text style={styles.detailValue}>{selectedPoint.description}</Text>
                      </View>
                    )}
                    
                    {selectedPoint.estimated_time && (
                      <View style={styles.detailRow}>
                        <Text style={styles.detailLabel}>Hora estimada:</Text>
                        <Text style={styles.detailValue}>{selectedPoint.estimated_time}</Text>
                      </View>
                    )}
                  </View>
                )}
              </View>
            </View>
          </Modal>
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  list: {
    flex: 1,
  },
  emptyText: {
    textAlign: 'center',
    color: '#7f8c8d',
    fontStyle: 'italic',
    padding: 20,
  },
  pointItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  pointOrder: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#e74c3c',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 15,
  },
  pointOrderText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
  pointInfo: {
    flex: 1,
  },
  pointName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  pointCoordinates: {
    fontSize: 12,
    color: '#7f8c8d',
    marginTop: 2,
  },
  pointAltitude: {
    fontSize: 12,
    color: '#7f8c8d',
    marginTop: 2,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    width: '80%',
    maxWidth: 400,
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    paddingBottom: 10,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2c3e50',
  },
  modalBody: {
    marginTop: 10,
  },
  detailRow: {
    marginBottom: 10,
  },
  detailLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginBottom: 2,
  },
  detailValue: {
    fontSize: 16,
    color: '#2c3e50',
  },
});

export default MissionPointsList;